export default {
  lrrInfoBlockTitle: {
    id: 'resolution_flow_lrr_info_block_title',
    defaultMessage:
      'Our agents are busier than usual, so replies may take longer.',
  },
  lrrInfoBlockContent: {
    id: 'resolution_flow_lrr_info_block_content',
    defaultMessage:
      'For the fastest solution, choose a repair, replacement, or refund option below.',
  },
}
